import Phaser from 'phaser'
import { BootScene } from './scenes/BootScene'
import { PreloadScene } from './scenes/PreloadScene'
import { MainMenuScene } from './scenes/MainMenuScene'
import { GameScene } from './scenes/GameScene'
import { MiniGameCompleteScene } from './scenes/minigames/MiniGameCompleteScene'
import { TestMiniGameScene } from './scenes/minigames/TestMiniGameScene'
import { ChoppingMiniGameScene } from './scenes/minigames/ChoppingMiniGameScene'
import { StirringMiniGameScene } from './scenes/minigames/StirringMiniGameScene'
import { JarringMiniGameScene } from './scenes/minigames/JarringMiniGameScene'

/**
 * Game configuration
 * Cooking Mama-style games typically use a fixed resolution
 * that scales to fit the screen while maintaining aspect ratio
 */
export const GAME_WIDTH = 800
export const GAME_HEIGHT = 600

export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO, // WebGL with Canvas fallback
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  parent: 'game-container',
  backgroundColor: '#2d1b4e',

  // Scale configuration for responsive design
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    min: {
      width: 400,
      height: 300,
    },
    max: {
      width: 1600,
      height: 1200,
    },
  },

  // Physics - using Arcade for simple 2D games
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: import.meta.env.DEV, // Show debug in development
    },
  },

  // Input configuration for touch support
  input: {
    activePointers: 3, // Support multi-touch
    touch: {
      capture: true,
    },
  },

  // Scene order matters - first scene starts automatically
  scene: [
    BootScene,
    PreloadScene,
    MainMenuScene,
    GameScene,
    MiniGameCompleteScene,
    TestMiniGameScene,
    ChoppingMiniGameScene,
    StirringMiniGameScene,
    JarringMiniGameScene,
  ],
}
